import Cookies from 'js-cookie'

export const TokenKey = 'my-token'
export const ServerTimeKey = 'server-time'

export function getToken() {
  return Cookies.get(TokenKey)
}



export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function setIsOlePwd(IsOldPwd) {
  return Cookies.set("IsOldPwd",IsOldPwd)
}

export function getIsOlePwd() {
  return Cookies.get("IsOldPwd")
}

export function removeIsOlePwd() {
  return Cookies.remove("IsOldPwd")
}

export function getXcookie (tokenName ) {
  return Cookies.get(tokenName)
}

export function setXcookie (tokenName,value ) {
  return Cookies.set(tokenName,value)
}


export function removeXcookie(tokenName) {
  return Cookies.remove(tokenName)
}

export function getServerTime() {
  return Cookies.get(ServerTimeKey)
}

export function setServerTime(token) {
  return Cookies.set(ServerTimeKey, token)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js